import { render, staticRenderFns } from "./QandAs.vue?vue&type=template&id=52d89cb4&"
import script from "./QandAs.vue?vue&type=script&lang=js&"
export * from "./QandAs.vue?vue&type=script&lang=js&"
import style0 from "./QandAs.vue?vue&type=style&index=0&id=52d89cb4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports